import axios from "axios";

const API = axios.create({
  baseURL: "http://163.227.92.37:5556",
});

export default API;
